import React from "react";

const About = () => {
  return (
    <div style={{ minHeight: "100vh" }}>
      <h1>About</h1>
      <p>
        The website is basically made by React.js. Practising for the API usage
        and rendering system in JSX.
      </p>
    </div>
  );
};

export default About;
